'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _comLabRRSS = require('./comLabRRSS.scss');

var _comLabRRSS2 = _interopRequireDefault(_comLabRRSS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = [{
  name: 'facebook',
  icon: 'icon-fb',
  url: 'http://www.facebook.com/sharer/sharer.php?u='
}, {
  name: 'twitter',
  icon: 'icon-twitter',
  url: 'https://twitter.com/intent/tweet?url='
}, {
  name: 'whatsapp',
  icon: 'icon-whatsup',
  url: 'https://web.whatsapp.com/send?text=',
  urlMobile: 'whatsapp://send?text='
}];

var styles = {
  horizontal: {
    flexDirection: 'row'
  },
  vertical: {
    flexDirection: 'column'
  }
};

var ComLabRRSS = function (_Component) {
  (0, _inherits3.default)(ComLabRRSS, _Component);
  (0, _createClass3.default)(ComLabRRSS, [{
    key: 'direction',
    get: function get() {
      return !this.props.horizontal ? styles.vertical : styles.horizontal;
    }
  }]);

  function ComLabRRSS(props) {
    (0, _classCallCheck3.default)(this, ComLabRRSS);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComLabRRSS.__proto__ || (0, _getPrototypeOf2.default)(ComLabRRSS)).call(this, props));

    _this.state = {
      openShare: _this.props.expanded,
      opened: false,
      isMobile: false
    };

    _this.openPopUp = _this.openPopUp.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.getShareTwText = _this.getShareTwText.bind(_this);
    _this.getShareWuText = _this.getShareWuText.bind(_this);
    _this.toggleShare = _this.toggleShare.bind(_this);
    _this.getDefinition = _this.getDefinition.bind(_this);
    _this.window = null;
    return _this;
  }

  (0, _createClass3.default)(ComLabRRSS, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.window = window;
    }
  }, {
    key: 'getShareTwText',
    value: function getShareTwText() {
      var str = _reactRouter.browserHistory.getCurrentLocation().pathname;
      var res = str.split('/');
      var shareTwText = '';
      if (this.props.metadata['/' + res[res.length - 2] + '/']) {
        shareTwText = this.props.metadata['/' + res[res.length - 2] + '/'].twitterText;
      } else {
        shareTwText = this.props.metadata['/'].twitterText;;
      }
      return shareTwText;
    }
  }, {
    key: 'getShareWuText',
    value: function getShareWuText() {
      var str = _reactRouter.browserHistory.getCurrentLocation().pathname;
      var res = str.split('/');
      var shareWuText = '';
      if (this.props.metadata['/' + res[res.length - 2] + '/']) {
        this.props.metadata['/' + res[res.length - 2] + '/'].meta.map(function (metaValue, key) {
          if (metaValue.property === 'og:description') {
            shareWuText = metaValue.content;
          }
        });
      } else {
        /* this.props.metadata['/'].meta.map((metaValue, key) => {
          if(metaValue.property === 'og:description'){
            shareWuText = metaValue.content;
          }
        }); */
        shareWuText = this.props.metadata['/'].twitterText;
      }
      return shareWuText;
    }
  }, {
    key: 'getDefinition',
    value: function getDefinition(element) {
      var result = void 0;
      config.map(function (item) {
        if (item.name === element) {
          result = item;
        }
      });
      return result;
    }
  }, {
    key: 'openPopUp',
    value: function openPopUp(e) {

      var url = '';
      var element = void 0;
      if (e.target.children[0]) {
        element = e.target.children[0].value;
      } else {
        element = e.target.value;
      }
      var textTwShare = '';
      var urlShare = '';

      var customWidth = 560;
      var customHeight = 400;

      var defs = this.getDefinition(element);

      switch (element) {
        case 'twitter':
          textTwShare = this.getShareTwText(); // TODO: Este código levanta desde el header un mensaje para compatir !== '' ? data.text : this.getShareTwText('twitter');
          urlShare = defs.shareUrl || this.window && this.window.location.href;
          url = defs.url + '&text=' + textTwShare;
          break;
        case 'whatsapp':
          textTwShare = this.getShareWuText();
          urlShare = defs.shareUrl || this.window && this.window.location.href;
          url = this.state.isMobile ? '' + defs.urlMobile + textTwShare : '' + defs.url + textTwShare;
          customWidth = 800;
          customHeight = 800;
          break;
        case 'facebook':
          urlShare = defs.shareUrl || this.window && this.window.location.href;
          url = '' + defs.url + urlShare;
          customWidth = 820;
          customHeight = 580;
          break;
        default:
          break;
      }

      urlShare = encodeURIComponent(urlShare);

      this.props.analytics ? Analytics.adobeShare() : false;
      this.window && this.window.open(url, '_blank', 'toolbar=no, scrollbars=no, resizable=yes, top=100, left=500, width=' + customWidth + ', height=' + customHeight);
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.setState({
        opened: !this.state.opened
      });
    }
  }, {
    key: 'toggleShare',
    value: function toggleShare() {
      this.setState({ openShare: !this.state.openShare });
    }

    // addShareIcon() {
    //   return this.props.expanded ? null : (
    //     <p className='rrssContainer__iconOpen' onClick={this.toggleShare}>
    //       <i className='icon-share' />
    //     </p>
    //   );
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.isMobile && this.props.isMobile != this.state.isMobile) {
        this.setState({
          isMobile: this.props.isMobile
        });
      };

      var classElem = (0, _classnames2.default)({
        rrssContainer__iconList__elem: true,
        rrssContainer__iconList__elemMobile: this.state.isMobile
      });

      var parentClass = (0, _classnames2.default)({
        open: this.state.openShare,
        close: !this.state.openShare,
        rrssContainer: true,
        rrssContainer__defaultStyle: true
      });

      return _react2.default.createElement(
        'div',
        { className: parentClass },
        _react2.default.createElement(
          'ul',
          { className: 'rrssContainer__iconList', style: this.direction },
          config.map(function (item, i) {
            return _react2.default.createElement(
              'li',
              {
                key: 'rrss-' + item.name,
                onClick: function onClick(e) {
                  return _this2.openPopUp(e);
                },
                className: classElem
              },
              _react2.default.createElement('button', {
                value: item.name,
                className: 'rrssContainer__iconList__elem__icon icon ' + item.icon
              })
            );
          })
        )
      );
    }
  }]);
  return ComLabRRSS;
}(_react.Component);

exports.default = ComLabRRSS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ComLabRRSS/ComLabRRSS.js
// module id = 692
// module chunks = 0